import { css } from 'styled-components';
import token from 'styled-token';
import { StyledInput } from '../../components/Input/Input.styles';
import { StyledLabel } from '../../components/Label/Label.styles';
import { fontWeightMixin } from '../fontWeightMixin';
import { ie11Mixin } from '../ie11Mixin';
import { typographyMixin } from '../typographyMixin';
var labelExpandCSS = function labelExpandCSS(props) {
  return token({
    fontTypeInput: 'LabeledInput.fontTypeInput',
    transition: 'LabeledInput.transition',
    horizontalSpacing: 'LabeledInput.horizontalSpacing'
  }, function (_ref) {
    var fontTypeInput = _ref.fontTypeInput,
      transition = _ref.transition,
      horizontalSpacing = _ref.horizontalSpacing;
    return css(["", " position:absolute;left:", "px;top:50%;transform:translateY(-50%);transform-origin:left top;transition:", ";pointer-events:none;"], typographyMixin(Object.assign({
      fontType: fontTypeInput
    }, props)), horizontalSpacing, transition);
  })(props);
};
var labelShrinkCSS = function labelShrinkCSS(props) {
  return token({
    fontTypeLabel: 'LabeledInput.fontTypeLabel',
    scale: 'LabeledInput.scale'
  }, function (_ref2) {
    var fontTypeLabel = _ref2.fontTypeLabel,
      scale = _ref2.scale;
    return css(["transform:translateY(-100%) scale(", ");font-weight:", ";"], scale, fontWeightMixin(fontTypeLabel));
  })(props);
};
var labelCSS = function labelCSS(props) {
  return css(["> ", "{", " ", "}> ", ":focus,> ", ":not(:placeholder-shown),> ", ":-webkit-autofill{& ~ ", "{", "}}", "[readonly]{& ~ ", "{left:0;}}"], StyledLabel, labelExpandCSS(props), ie11Mixin(labelShrinkCSS(props)), StyledInput, StyledInput, StyledInput, StyledLabel, labelShrinkCSS(props), StyledInput, StyledLabel);
};
var inputCSS = function inputCSS(props) {
  return token({
    transition: 'LabeledInput.transition',
    paddingBase: 'LabeledInput.paddingBase',
    verticalSpacing: 'LabeledInput.verticalSpacing'
  }, function (_ref3) {
    var transition = _ref3.transition,
      paddingBase = _ref3.paddingBase,
      verticalSpacing = _ref3.verticalSpacing;
    return css(["> ", "{padding-top:", "px;padding-bottom:", "px;transition:", ";&::placeholder{transition:", ";}&:not(:focus)::placeholder{color:transparent;}}"], StyledInput, paddingBase + verticalSpacing, paddingBase - verticalSpacing, transition, transition);
  })(props);
};

/** @class LabeledInputMixin */
/** @method */
export var LabeledInputMixin = function LabeledInputMixin(props) {
  return css(["position:relative;", " ", ""], labelCSS(props), inputCSS(props));
};